module.exports = __webpack_public_path__ + "static/hero-06-3ed2077d7cca68eec45846f47cc22272.jpg";